import React from 'react';

const NotFound: React.FC = () => {
    return(
        <title>404 Page not found</title>
    );
}

export default NotFound;